import { render, staticRenderFns } from "./UserAssignRolesForm.vue?vue&type=template&id=3bcc64ac"
import script from "./UserAssignRolesForm.vue?vue&type=script&lang=js"
export * from "./UserAssignRolesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports